import { render } from "./TeamFootball.vue?vue&type=template&id=2d218798&scoped=true&ts=true"
import script from "./TeamFootball.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamFootball.vue?vue&type=script&setup=true&lang=ts"

import "./TeamFootball.vue?vue&type=style&index=0&id=2d218798&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d218798"],['__file',"src/components/player/TeamFootball.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d218798"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d218798', __exports__)) {
    console.log('reload')
    api.reload('2d218798', __exports__)
  }
  
  module.hot.accept("./TeamFootball.vue?vue&type=template&id=2d218798&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2d218798', render)
  })

}


export default __exports__